import React, { useState } from "react"; 
import axios from "axios"; 
import PasswordInput from "./PasswordInput"; 
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../styles/Button";
import styled from "styled-components";
import {toast , Toaster } from 'react-hot-toast';

const ForgotPassword = () => { 
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ 
    email: "", 
    newPassword: "", 
    confirmPassword: ""
  });

  const handleChange = (e) => { 
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value, 
    }); 
  }; 

  const handleSubmit = async (e) => { 
    e.preventDefault(); 

    if (formData.newPassword !== formData.confirmPassword){ 
      toast.error("Passwords do not match"); 
        return; }
   
    try { 
      const res = await axios.post( "/api/forgot-password", formData ); 
       toast.success(res.data.message || "Password change successful");
      navigate("/username");
    } catch (error) { 
      toast.error(error.response?.data?.error || "Something went wrong");
    } 
  }; 
  return ( 
  <Wrapper> 
     <Toaster position="top-center" reverseOrder={false} />
    <div className='user-card'>
        <header className='user-header'>
        <h4 className="greeting">Forgot Password</h4> 
        <p className="subtitle">Change your password</p>
      </header> 
        
        <hr /> 

        <form onSubmit={handleSubmit} autoComplete="off">
        
        <div className="form-fields">
            <input 
            type="email" 
            name="email" 
            placeholder="Email" 
            value={formData.email} 
            onChange={handleChange} 
            /> 
            <PasswordInput 
            name="newPassword" 
            placeholder="New Password" 
            onChange={handleChange} 
            /> 
            <PasswordInput 
            name="confirmPassword" 
            placeholder="Confirm Password" 
            onChange={handleChange} 
            /> 
            <Button 
            type="submit"> 
              Password Change
            </Button>   
          </div>         
        </form> 
        <hr /> 
            <p className="user-para"> Back to Login?{" "} 
              <span className="Linkspan"> 
              <Link to="/">Login</Link> 
              </span> 
            </p> 
    </div> 
  </Wrapper>
      ); 
    }; 
  
  const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3rem;

  .user-card {
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    border-radius: 8px;
    background-color:${({ theme }) => theme.colors.bg};
    max-width: 400px;
    width: 100%;
    text-align: center;
  }

  .user-header {
    margin-bottom: 1.5rem;
  }

  .greeting {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

   .subtitle {
    font-size: 1.5rem;
    color: #0073e6;
  }

  hr {
    border: none;
    border-top: 1px solid #ccc;
    margin: 1.5rem 0;
  }

  
 .form-fields {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }
  
  .password-input {
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1.2rem;
    width: 100%;
  }

  hr {
    margin-top: 1.2rem;
    width: 100%;
    border: 1px solid black;
  }

  .user-para {
    text-align: center;
    font-size: 1.5rem;
    margin-top: 1rem;
  }

  .linkspan {
     color: #000;
    font-weight: 600;
    text-decoration: none;
  }

  
`;
    export default ForgotPassword;